import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import MultiselectExtension from "../MultiselectExtension";
import { Form } from "react-bootstrap";
import { updateUserProfile } from "../../api";
import NumberFormat from "react-number-format";
import { isCreatorOrAdministrator, isExternalContributorOrExternalView } from "../../utils/UserInfo";
import CommToolContext from "../../containers/common/comm_tool_context";
import Cookies from 'js-cookie'

function UserPreferenceDialog(props) {
  const { context, userProfile, setUserProfile, onClose, stationRegions, stationAreas, pcAreas } = props;
  const [myProjectStatus, setMyProjectStatus] = useState((userProfile.myProjectStatus === null || userProfile.myProjectStatus === '') ?
    "" : userProfile.myProjectStatus);
  const [myStationRegions, setMyStationRegions] = useState(userProfile.myStationRegions);
  const [myTFSStationAreas, setMyTFSStationAreas] = useState(userProfile.myTFSStationAreas);
  const [myTFSPCAreas, setMyTFSPCAreas] = useState(userProfile.myTFSPCAreas);
  const [myProjectsFlag, setMyProjectsFlag] = useState(userProfile.myProjectsFlag);
  const [phoneNumber, setPhoneNumber] = useState(userProfile.phoneNumber);
  const [cellNumber, setCellNumber] = useState(userProfile.cellNumber);
  const [saveBtnDisable, setSaveBtnDisable] = useState(true);
  const [filtersChanged, setFiltersChanged] = useState(false);
  const [applicationMenu, setApplicationMenu] = useState(userProfile.applicationMenu)
  const [applicationMenuChanged, setApplicationMenuChanged] = useState(false)

  let myProjectStatusChanged = false;
  let myStationRegionChanged = false;
  let myTFSStationAreaChanged = false;
  let myTFSPCAreaChanged = false;
  let myProjectsFlagChanged = false;
  let phoneChanged = false;
  let cellChanged = false;
  let isExternalUser = isExternalContributorOrExternalView();

  useEffect(() => {
    if (isExternalUser && myProjectStatus !== 'A' && myProjectStatus !== 'C') {
      setMyProjectStatus('A');
    }
    if (isExternalUser) {
      setMyProjectsFlag('Y');
    }
  }, [props]);

  function handleMyStatusChange(e) {
    const selection = e.currentTarget.value;
    myProjectStatusChanged = false;
    setMyProjectStatus(selection? selection : null);
    if (selection && selection !== userProfile.dfltProjectStatus) {
      myProjectStatusChanged = true;
    }
    setSaveBtnDisable(!(applicationMenu!=null && selection!=null && myProjectStatusChanged) );
    setFiltersChanged(myProjectStatusChanged === true || myStationRegionChanged === true || myTFSStationAreaChanged === true
      || myTFSPCAreaChanged === true || myProjectsFlagChanged === true || applicationMenuChanged);
  }

  function handleMyProjectChange(e) {
    const selection = e.currentTarget.value;
    myProjectsFlagChanged = false;
    //console.log('selection....', selection);
    setMyProjectsFlag(selection);
    if (selection !== userProfile.myProjectsFlag) {
      myProjectsFlagChanged = true;
    }
    setSaveBtnDisable(!(applicationMenu!=null && myProjectStatus!=null && myProjectsFlagChanged))
    setFiltersChanged(myProjectStatusChanged === true || myStationRegionChanged === true || myTFSStationAreaChanged === true
      || myTFSPCAreaChanged === true || myProjectsFlagChanged === true || applicationMenuChanged);
  }

  function handleRegionChange(optionsList, selectedItem) {
    let str = null;
    if (optionsList.length > 0) {
      str = optionsList.sort(function (a, b) { return (a.id - b.id) }).map(t => { return t.name }).join(',');
    }
    setMyStationRegions(str);
    myStationRegionChanged = false
    if (str !== userProfile.myStationRegions) {
      myStationRegionChanged = true
    }
    setSaveBtnDisable(!(applicationMenu!=null && myProjectStatus!=null && myStationRegionChanged))
    setFiltersChanged(myProjectStatusChanged === true || myStationRegionChanged === true || myTFSStationAreaChanged === true
      || myTFSPCAreaChanged === true || myProjectsFlagChanged === true || applicationMenuChanged);
  }

  function handleStationAreaChange(optionsList, selectedItem) {
    let str = null;
    if (optionsList.length > 0) {
      str = optionsList.sort(function (a, b) { return (a.id - b.id) }).map(t => { return t.name }).join(',');
    }
    setMyTFSStationAreas(str);
    myTFSStationAreaChanged = false
    if (str !== userProfile.myTFSStationAreas) {
      myTFSStationAreaChanged = true
    }
    setSaveBtnDisable(!(applicationMenu!=null && myProjectStatus!=null && myTFSStationAreaChanged) )
    setFiltersChanged(myProjectStatusChanged === true || myStationRegionChanged === true || myTFSStationAreaChanged === true
      || myTFSPCAreaChanged === true || myProjectsFlagChanged === true || applicationMenuChanged);
  }

  function handlePCAreaChange(optionsList, selectedItem) {
    let str = null;
    if (optionsList.length > 0 ) {
      str = optionsList.sort(function (a, b) { return (a.id - b.id) }).map(t => { return t.name }).join(',');
    }
    setMyTFSPCAreas(str);
    myTFSPCAreaChanged = false
    if (str !== userProfile.myTFSPCAreas) {
      myTFSPCAreaChanged = true
    }
    setSaveBtnDisable(!(applicationMenu!=null && myProjectStatus!=null && myTFSPCAreaChanged) )
    setFiltersChanged(myProjectStatusChanged === true || myStationRegionChanged === true || myTFSStationAreaChanged === true
      || myTFSPCAreaChanged === true || myProjectsFlagChanged === true || applicationMenuChanged);
  }

  function handlePhoneChange(e) {
    const selection = e.currentTarget.value;
    phoneChanged = false;
    setPhoneNumber(selection);
    if (selection !== userProfile.phoneNumber) {
      phoneChanged = true;
    }
    setSaveBtnDisable(!(applicationMenu!=null && myProjectStatus!=null && phoneChanged))
  }
  function handleCellChange(e) {
    const selection = e.currentTarget.value;
    cellChanged = false;
    setCellNumber(selection);
    if (selection !== userProfile.cellNumber) {
      cellChanged = true;
    }
    setSaveBtnDisable(!(applicationMenu!=null && myProjectStatus!=null && cellChanged))
  }

  function handleApplicationMenuChange(e) {
    setMyProjectStatus(null)
    setSaveBtnDisable(true)
    const menu = e.target.value;

    // if (applicationMenu != menu && menu === 'DATA_ENTRY_TRACKER') {
    //   setMyProjectStatus('DT_P')
    // } else if (applicationMenu != menu && menu === 'CHECKLIST') {
    //   setMyProjectStatus('A')
    // }
    if (menu === 'CHECKLIST' || menu === 'DATA_ENTRY_TRACKER' || menu === 'FMP_TRACKER' || menu === 'ALL') {
      setApplicationMenu(e.target.value);
      setApplicationMenuChanged(true)
      //setSaveBtnDisable(e.target.value && myProjectStatus? false: true)
    } else {
      setApplicationMenu(null);
      setApplicationMenuChanged(false)
      //setSaveBtnDisable(true)
    }
  }

  const clearAllStationRegions = () => {
    setMyStationRegions(null)
  }

  const clearAllTFSStationAreas = () => {
    setMyTFSStationAreas(null)
  }

  const clearAllTFSPCAreas = () => {
    setMyTFSPCAreas(null)
  }

  const ChecklistOptions = () => {

    return (<>
      {!isExternalUser && <option value={'ALL'}>All</option>}
      {!isExternalUser && <option value={'U'}>Upcoming</option>}
      {!isExternalUser && <option value={'D'}>In Development</option>}
      {!isExternalUser && <option value={'R'}>Released</option>}
      <option value={'A'}>Active</option>
      <option value={'C'}>Closed</option>
      {!isExternalUser && <option value={'N'}>Checklist NA</option>}
      {isCreatorOrAdministrator() &&<option value={"ADMIN"}>Admin</option>}
    </>)
  }

  const DataTrackerOptions = () => {
    return (<><option value={'DT_ALL'}>All</option>
      <option value={'DT_P'}> In Pending</option>
      <option value={'DT_A'}> In Progress</option>
      <option value={'DT_H'}> On Hold</option>
      <option value={'DT_N'}> NA</option>
      <option value={'DT_C'}> Complete</option>
      <option value={'DT_D'}> Matched/Duplicate</option>
    </>)
  }

  const FMPTrackerOptions = () => {
    return (<><option value={'FMP_A'}>All</option>
      <option value={'FMP_P'}> Pending</option>
      <option value={'FMP_G'}> In Progress</option>
      <option value={'FMP_R'}> Under Review</option>
      <option value={'FMP_B'}> As-Builts</option>
      <option value={'FMP_C'}> Complete</option>
    </>)
  }


  return (
    <div className='react-confirm-alert-body'>
      <h4><b>User Preferences</b></h4>
      Set up defaults on how the application will look when you log in.
      <hr />
      <div className='edit-dialog--task'>
        <Row style={{ textAlign: 'left' }}>
          <Col xs={5} md={5} lg={5}>
            <b>Application Menu:</b>
          </Col>
          <Col xs={7} md={7} lg={7}>
            <Form.Control as='select' id='user-dashboard-selector' value={applicationMenu} onChange={handleApplicationMenuChange}>
              <option value=""></option>
              <option value={'DATA_ENTRY_TRACKER'}>Data Entry Tracker</option>
              <option value={'CHECKLIST'}>Commissioning Checklist</option>
              <option value={'FMP_TRACKER'}>FMP Tracker</option>
              <option value={'ALL'}>All</option>
            </Form.Control>
          </Col>
        </Row>
        <hr />
        <Row style={{ textAlign: 'left' }}>
          <Col xs={5} md={5} lg={5}>
            <b>Default Dashboard View:</b>
          </Col>
          <Col xs={7} md={7} lg={7}>
            <Form.Control as='select' id='user-dashboard-selector' value={myProjectStatus} onChange={handleMyStatusChange}>
              {applicationMenu === 'CHECKLIST' &&
                <optgroup label='Commissioning Checklist'>
                    <ChecklistOptions />
                </optgroup>
              }
               {applicationMenu === 'DATA_ENTRY_TRACKER' &&
                <optgroup label='Data Entry Tracker'>
                    <DataTrackerOptions />
                </optgroup>
              }
                {applicationMenu === 'FMP_TRACKER' &&
                <optgroup label='FMP Tracker'>
                    <FMPTrackerOptions />
                </optgroup>
              }
              {applicationMenu === 'ALL' &&
                <>
                  <option value={""}></option>
                  <optgroup label='Commissioning Checklist'>
                    <ChecklistOptions />
                  </optgroup>
                  <optgroup label='Data Entry Tracker'>
                    <DataTrackerOptions />
                  </optgroup>
                  <optgroup label='FMP Tracker'>
                    <FMPTrackerOptions />
                  </optgroup>
                </>
              }        
               
            </Form.Control>
          </Col>
        </Row>
        <hr />
        <Row style={{ textAlign: 'left' }}>
          <Col xs={4} md={4} lg={4}>
            <b>Station Region:</b>
          </Col>
          <Col xs={8} md={8} lg={8}>
            <MultiselectExtension options={stationRegions}
              selectedValues={myStationRegions !== null ?
                stationRegions.filter(t => myStationRegions.split(',').includes(t.name)) : []}
              onSelect={handleRegionChange}
              onRemove={handleRegionChange}
              showCheckbox={true}
              displayValue="name"
              placeholder={myStationRegions !== null ?
                myStationRegions : 'Select Station Regions'}
                resetSelectField={clearAllStationRegions}
            />
          </Col>
        </Row>
        <Row style={{ textAlign: 'left' }}>
          <Col xs={4} md={4} lg={4}>
            <b>TFS Station Area:</b>
          </Col>
          <Col xs={8} md={8} lg={8}>
            <MultiselectExtension options={stationAreas}
              selectedValues={myTFSStationAreas !== null ?
                stationAreas.filter(t => myTFSStationAreas.split(',').includes(t.name)) : []}
              showCheckbox={true}
              onSelect={handleStationAreaChange}
              onRemove={handleStationAreaChange}
              displayValue="name"
              placeholder={myTFSStationAreas !== null ?
                myTFSStationAreas : 'Select TFS Station Areas'}
              resetSelectField={clearAllTFSStationAreas}
            />
          </Col>
        </Row>
        <Row style={{ textAlign: 'left' }}>
          <Col xs={4} md={4} lg={4}>
            <b>TFS P&C Area:</b>
          </Col>
          <Col xs={8} md={8} lg={8}>
            <MultiselectExtension options={pcAreas}
              selectedValues={myTFSPCAreas !== null ?
                pcAreas.filter(t => myTFSPCAreas.split(',').includes(t.name)) : []}
              showCheckbox={true}
              onSelect={handlePCAreaChange}
              onRemove={handlePCAreaChange}
              displayValue="name"
              placeholder={myTFSPCAreas !== null ?
                myTFSPCAreas : 'Select TFS P&C Areas'}
              resetSelectField={clearAllTFSPCAreas}
            />
          </Col>
        </Row>
        <Row style={{ textAlign: 'left' }}>
          <Col xs={4} md={4} lg={4}>
            <b>My Projects:</b>
          </Col>
          <Col xs={6} md={6} lg={6}>
            <Form.Control as='select' id='user-myprojects-selector' value={myProjectsFlag} style={{ marginLeft: '5px' }}
              onChange={handleMyProjectChange} disabled={isExternalUser}>
              <option value={''}></option>
              <option value={'Y'}>My Projects</option>
              <option value={'N'}>Not My Projects</option>
            </Form.Control>
          </Col>
        </Row>
        <hr />
        <Row style={{ textAlign: 'left' }}>
          <Col xs={6} md={6} lg={6}>
            <b>Office Phone:</b>
            <NumberFormat
              className='text-control'
              id='phoneNumber'
              autoComplete='off'
              type='text'
              value={phoneNumber}
              onChange={handlePhoneChange}
              placeholder='xxx-xxx-xxxx'
              format='###-###-####'
              style={{ borderColor: 'lightgrey' }}
              mask=''
              disabled={false}
            />
          </Col>
          <Col xs={6} md={6} lg={6}>
            <b>Cell Phone:</b>
            <NumberFormat
              className='text-control'
              id='cellPhone'
              autoComplete='off'
              type='text'
              value={cellNumber}
              onChange={handleCellChange}
              placeholder='xxx-xxx-xxxx'
              format='###-###-####'
              style={{ borderColor: 'lightgrey' }}
              mask=''
              disabled={false}
            />
          </Col>
        </Row>
      </div>
      <hr />
      <Row style={{ textAlign: 'left' }}>
        <Col xs={6} md={3} lg={3}>
          <button disabled={saveBtnDisable}
            className='btn btn-primary start-5'
            onClick={async () => {
              const newAttributes = {
                myProjectStatus: myProjectStatus,
                myStationRegions: myStationRegions,
                myTFSStationAreas: myTFSStationAreas,
                myTFSPCAreas: myTFSPCAreas,
                myProjectsFlag: myProjectsFlag,
                phoneNumber: phoneNumber,
                cellNumber: cellNumber,
                applicationMenu: applicationMenu
              };
              const updatedProfile = {
                ...userProfile,
                ...newAttributes
              };
              const newProfile = await updateUserProfile(updatedProfile);
              setUserProfile(newProfile);
              //console.log('new profile.................', newProfile);
              //console.log('filtersChanged.................', filtersChanged);
              const filterAttributes = { filtersChanged: filtersChanged };
              const filterProfile = {
                ...newProfile,
                ...filterAttributes
              }
              context.setUserProfile(filterProfile);
              //console.log('context..........',props);
              onClose();
            }}
          >
            Save
          </button>
        </Col>
        <Col xs={8} md={4} lg={3}>
          <button className='btn btn-primary start-5' onClick={() => {
            onClose();
          }}>
            Cancel
          </button>
        </Col>
      </Row>
    </div>
  );
}

UserPreferenceDialog.contextType = CommToolContext;
export default UserPreferenceDialog;